import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { noHeaderCss } from "../../../sass/Main";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import TextField from "@material-ui/core/TextField/index";
import Button from "@material-ui/core/Button/index";
import Grid from "@material-ui/core/Grid/index";
import { wizardUpdateProfile, wizardChooseConnectors } from "../../../redux/actions/gettingStartedWizardActions";

class WelcomeForm extends React.Component {
  renderTextField = ({ label, input, meta: { touched, invalid, error }, ...custom }) => (
    <TextField
      label={label}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && error}
      {...input}
      {...custom}
    />
  );

  onSubmit = formValues => {
    this.props.wizardUpdateProfile(this.props.cognitoUser, formValues);
  };

  render() {
    const { classes } = this.props;

    return (
      <form className={classes.form} onSubmit={this.props.handleSubmit(this.onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.textCentered}>
            <Field name="firstName" component={this.renderTextField} label="First Name" required />
          </Grid>
          <Grid item xs={6} className={classes.textCentered}>
            <Field name="lastName" component={this.renderTextField} label="Last Name" required />
          </Grid>
          <Grid item xs={6} className={classes.textCentered}>
            <Field name="companyName" component={this.renderTextField} label="Company Name" required />
          </Grid>
          <Grid item xs={6} className={classes.textCentered}>
            <Field name="jobTitleOrRole" component={this.renderTextField} label="Job Title or Role" />
          </Grid>
          <Grid item xs={6} className={classes.textCentered}>
            <Field name="phoneNumber" component={this.renderTextField} label="Phone Number" placeholder="+1234567890" />
          </Grid>
          <Grid item xs={12} className={classes.textCentered}>
            <Button size="large" className={classes.submit} type="submit" variant="contained" color="primary">
              Continue
            </Button>
        </Grid>

          {/* Uncomment the following block if you need a button for skipping the "Update profile" form */}
          {/*<Grid item xs={12} className={classes.textCentered}>*/}
          {/*  <Typography className={classes.pSize} component="p">*/}
          {/*    Or{" "}*/}
          {/*    <Link*/}
          {/*      color="secondary"*/}
          {/*      href="#"*/}
          {/*      onClick={e => {*/}
          {/*        e.preventDefault();*/}
          {/*        this.props.wizardChooseConnectors();*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      Skip this step*/}
          {/*    </Link>*/}
          {/*    .*/}
          {/*  </Typography>*/}
          {/*</Grid>*/}
        </Grid>
      </form>
    );
  }
}

const validate = formValues => {
  const errors = {};
  const genericMessage = "Required";
  const requiredFields = ["firstName", "lastName", "companyName"];

  requiredFields.forEach(field => {
    // Check if field value is nonexistent or only whitespace
    if (!formValues[field] || !formValues[field].trim().length) {
      errors[field] = genericMessage;
    }
  });

  return errors;
};

const WelcomeFormStyled = withStyles(noHeaderCss)(WelcomeForm);

const welcomeFormRedux = reduxForm({
  form: "welcomeForm",
  validate
})(WelcomeFormStyled);

const mapStateToProps = state => {
  return {
    cognitoUser: state.auth.cognitoUser
  };
};

export default connect(
  mapStateToProps,
  {
    wizardUpdateProfile,
    wizardChooseConnectors
  }
)(welcomeFormRedux);
